import Navbar from "../../NavBar/Navbar"
import SideBar from "../../NavBar/Sidebar"

interface ChildsProps {
    Component: () => JSX.Element
    logout: () => void
}

const PageStructure: React.FC<ChildsProps> = ({Component, logout}) => {
    return(
    <div className="sidebar-noneoverflow">
        <Navbar logout={logout}/>
    
        <div className="main-container" id="container">
            <SideBar/>
            <Component />
        </div>
    </div>
    )
}
export default PageStructure